import delegatePeople from "./people-right.png";
import { applicationsData } from "./applications.data";

import ApproveRequest from "./Modal/ApproveRequest/ApproveRequest";

import approveRequest from "./Modal/ApproveRequest/ApproveRequest";

import { Modal } from "../../Modal/Modal";
import { isTerminal } from "../../../../constants";

import {
    setCurrentRequestThunkAction,
} from "../../../../redux/actions/Requests/CurrentRequest/thunk/setCurrentRequest.thunk.action";
import RequestServices from "../../../../frontend.services/RequestServices/RequestServices";
import { unsetUserRequestAction } from "../../../../redux/actions/Requests/CurrentRequest/unsetUserRequest.action";
import UserRequestCard from "../ModalAssets/UserRequestCard/UserRequestCard";

import { LeftArrow } from "../../../../assets/icons/LeftArrow";
import { RightArrow } from "../../../../assets/icons/RightArrow";

import CustomLoader from "../../CustomLoader/CustomLoader";

import UButton from "../../Button/UButton/UButton";

import RecruitmentToWorkOnHolidaysModal
    from "../../../pages/HRServicesPage/LeaderRequestsPage/LRPage/RecruitmentToWorkOnHolidaysModal/RecruitmentToWorkOnHolidaysModal";

import {
    getGroupCurrentRequestThunkAction,
} from "../../../../redux/actions/CurrentDocument/thunk/getGroupCurrentRequest.thunk.action";

import {
    getIndividualCoefficientCardThunkAction,
} from "../../../../redux/actions/Requests/RequestsFromLeader/IndividualCoefficients/getIndividualCoefficientCardThunkAction";

import StageValidationHOC from "../../../../hocs/StageValidation.HOC";

import RequestConfirmation from "../../Modal/ModalConditions/Requests/RequestConfirmation/RequestConfirmation";

import ModalSuccess
    from "../../../pages/HRServicesPage/LeaderRequestsPage/LRPage/RecruitmentToWorkOnHolidays/ModalSuccess/ModalSuccess";


import { mode } from "../../../../app/mode";
import {
    getStructureTopThunkAction,
} from "../../../../redux/actions/Requests/LeaderRequests/thunk/getStructureTop.thunk.action";

import {
    getUserRequestsThunkAction,
} from "../../../../redux/actions/Requests/GetUserRequests/thunk/getUserRequests.thunk.action";

import { ClipLoader } from "react-spinners";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import moment from "moment";

// <ModalBanOverlay shown={true}>
//     <div style={{
//         display: "flex",
//         justifyContent: "center",
//         flexDirection: "column",
//         alignItems: "center",
//         background: "#FFFFFF",
//         minHeight: "40vh",
//         width: "70vw",
//         textAlign: "center",
//         padding: "20px",
//         gap: "30px",
//     }}>  </div>
//
// </ModalBanOverlay>


isTerminal ? import("./ApplicationsTerminal.scss") : import("./Applications.scss");

const Applications = (
    {
        setErrorModal,
        setErrDescription,
        currentRowsHandler,
        rowsPerPage,
        userRequests,
    },
) => {

    const dispatch = useDispatch();

    // TEST DELETE!!!!!
    const [modalStatus, setModalStatus] = useState(false);
    // const [stageModalWindow, setStageModalWindow] = useState(false);
    // const requests = useSelector((state) => state.requests);
    //
    // const [sendButtonLoading, setSendButtonLoading] = useState(false);
    //
    // const [selectedE, setSelectedE] = useState([]);
    //
    // const approveRequest = {
    //     back: () => {
    //         setStageModalWindow(null);
    //     },
    //     next: async (newTuple, props) => {
    //         try {
    //             // const response = await $api.post("v1/auth/verify/password", { password: password.password });
    //             // console.log("data:  ", response.data);
    //             newTuple[0][0].props.description = {
    //                 head: "Служебная записка принята",
    //                 subHead: " Служебная записка\n" +
    //                     "                               на тему  «Привлечение к\n" +
    //                     "                                работе в выходные\n" +
    //                     "                                и\n" +
    //                     "                                праздничные дни»\n" +
    //                     "                                принята.",
    //             };
    //             setStageModalWindow(StageValidationHOC(newTuple));
    //         } catch (e) {
    //
    //         }
    //     },
    //     props: {
    //         pids: selectedE,
    //
    //
    //     },
    // };
    // const actionsOK = {
    //     back: () => {
    //         console.log("BACK");
    //         setStageModalWindow(null);
    //         dispatch(getStructureTopThunkAction());
    //         dispatch(
    //             getUserRequestsThunkAction({
    //                 page: {
    //                     pageSize: requests?.userRequests?.pageSize,
    //                     pageNumber: requests?.userRequests?.pageNumber,
    //                 },
    //             }),
    //         );
    //
    //     },
    //     next: (newTuple) => {
    //         console.log("NEXT", newTuple);
    //         // dispatch(sendMemoThunkAction());
    //         // newTuple[1][0].props.name = "NEW HOC";
    //         // setStageModalWindow(StageValidationHOC(newTuple));
    //     },
    //     props: {
    //         name: "testHOC",
    //         pids: selectedE,
    //
    //
    //     },
    //     // newTuple: null,xx
    // };
    // const testHOC = StageValidationHOC([
    //     [approveRequest, ApproveRequest],
    //     [actionsOK, ModalSuccess],
    //     // [actionsOK, ModalSuccess],
    //
    //
    // ]);
    // // DELETE

    const [modalShownReferences, toggleModalShownReferences] = useState(false);
    const [description, setDescription] = useState("");
    const [itemOffset, setItemOffset] = useState(0);

    //START Pagination

    const [page, setPage] = useState({
        pageSize: 5,
        pageNumber: 1,

    });

    function changePageSize(number) {
        if (userRequests.totalCount < number) {
            setPage(
                {
                    pageNumber: 1,
                    pageSize: userRequests.totalCount,
                },
            );
            const temp = { pageNumber: 1, pageSize: userRequests.totalCount };
            dispatch(
                getUserRequestsThunkAction({
                    setErrorModal: setErrorModal,
                    setErrDescription: setErrDescription,
                    page: temp,
                }),
            );

        } else {

            setPage({
                pageNumber: 1,
                pageSize: number,

            });
            const temp = { pageNumber: 1, pageSize: number };
            dispatch(
                getUserRequestsThunkAction({
                    setErrorModal: setErrorModal,
                    setErrDescription: setErrDescription,
                    page: temp,
                }),
            );
        }

    }

    function changePageNumber(number) {
        setPage((prev) => {
            return {
                ...prev,
                pageNumber: number.selected + 1,
            };
        });
        const temp = { ...page, pageNumber: number.selected + 1 };
        dispatch(
            getUserRequestsThunkAction({
                setErrorModal: setErrorModal,
                setErrDescription: setErrDescription,
                page: temp,
            }),
        );
    }

    //END Pagination

    //
    // const endOffset = itemOffset + rowsPerPage;
    // const currentItems = userRequests.slice(itemOffset, endOffset);
    // const pageCount = Math.ceil(userRequests?.length / rowsPerPage);
    function clickHandlerReferences(request, uid, i) {
    console.log(document);
         document.body.style.overflow = "hidden"      ;
         const type = request.type;
        if (request.type === 22) {
            dispatch(getIndividualCoefficientCardThunkAction(uid, {
                setDescription: setDescription,
                markReviewed: true,
                isReviewed: request.isReviewed,
            }));
        }
        else if (request.type === 11) {
            // toggleModalShownReferences(false);
            dispatch(getGroupCurrentRequestThunkAction(uid, {}));
            // setModalStatus(true);
            // approveRequest.props.rvdDetails = uid;
            // actionsOK.props.rvdDetails = uid;
        }
        else {

            dispatch(setCurrentRequestThunkAction(uid, true, type,  { setDescription: setDescription }));
        }
            setModalStatus(false);
            toggleModalShownReferences(!modalShownReferences);

    }

    function closeHandlerReferences(e) {
       document.body.style.overflow = "auto";
        toggleModalShownReferences(false);
        dispatch(unsetUserRequestAction());
    }

    // const handlePageClick = (event) => {
    //     const newOffset = (event.selected * rowsPerPage) % userRequests.length;
    //     setItemOffset(newOffset);
    // };
    //
    // useEffect(() => {
    //     if (itemOffset < rowsPerPage) setItemOffset(0);
    //     setItemOffset(Math.floor(itemOffset / rowsPerPage) * rowsPerPage);
    // }, [itemOffset, rowsPerPage]);


    return !userRequests
        ? <CustomLoader />
        : (<div>
            <div className="table-container">
                <div className="table-container__delegation-legend ">
                    <div  className="table-container__delegation-legend__color-item"></div>
                    <div>Делегированная заявка
                    </div>
                </div>
                <table className="table">
                    <thead>
                        <tr className="table__row">
                            {applicationsData && applicationsData.map((el) => {
                                return (
                                    <th
                                        key={el.id}
                                        style={{ width: `${el.width}` }}
                                        className="table__row__item"
                                    >
                                        {el.title}
                                        {
                                            el.icon
                                                ? <img
                                                    src={el.icon}
                                                    alt="triangle"
                                                    className="header-triangle" />
                                                : null
                                        }
                                    </th>
                                );
                            })
                            }
                        </tr>
                    </thead>
                    {/*<tr>*/}
                    <tbody>
                        {userRequests && userRequests?.items && userRequests.items.map((el, i) => (
                            <tr
                                onClick={() => (clickHandlerReferences(el, el.uid, i))}
                                key={el.id}
                                className={el.isReviewed ? "row-request" : "row-request-active"}
                            >
                                <td style={{padding: "0 0 0 20px" }} className={ el.delegatePid && "colored-icon"} >

                                    {el.typeText}
                                </td>
                                <td style={{ width: isTerminal ? "137px" : "100px" }}>{el.orderNumber}</td>
                                <td style={{ width: isTerminal ? "160px" : "234px" }}>{el.typeName}</td>
                                <td style={{ width: isTerminal ? "139px" : "150px" }}>{el.statusName}</td>
                                <td style={{ width: isTerminal ? "224px" : "330px" }}>
                                    {
                                        el.employeeComment
                                            ? (el.employeeComment.length > 35
                                                ? el.employeeComment.slice(0, 35) + "..."
                                                : el.employeeComment)
                                            : "..."
                                    }
                                </td>
                                <td
                                    style={{ width: isTerminal ? "158px" : "145px" }}>
                                    {moment(el.creationTime).format("DD.MM.YYYY")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {
                    !userRequests?.items?.length
                        ? <div>

                        </div>
                        : <div className={isTerminal && "pagination-wrapper"}>
                            {!isTerminal && <div className="pagination-container">
                                <div className="pagination-container__rows">
                                    <div
                                        onClick={() => changePageSize(5)}
                                        className={userRequests.pageSize === 5 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                            5
                                    </div>
                                    <div
                                        onClick={() => changePageSize(10)}
                                        className={userRequests.pageSize === 10 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                            10
                                    </div>
                                    <div
                                        onClick={() => changePageSize(20)}
                                        className={userRequests.pageSize === 20 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>

                                            20
                                    </div>

                                    <div
                                        onClick={() => changePageSize(50)}
                                        className={userRequests.pageSize === 50 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                            50
                                    </div>
                                </div>
                            </div>
                            }
                            <ReactPaginate
                                className={"pagination"}
                                breakLabel=".."
                                nextLabel={isTerminal ? <RightArrow /> : ">"}
                                onPageChange={changePageNumber}
                                pageRangeDisplayed={3}
                                pageCount={userRequests.totalPages}
                                previousLabel={isTerminal ? <LeftArrow /> : "<"}
                                renderOnZeroPageCount={null}
                                forcePage={page.pageNumber - 1}
                            />
                        </div>


                }
            </div>
            {/*{mode === "UNSTABLE" ? <>  {stageModalWindow}*/}
            {/*</>*/}
            {/*    : null*/}
            {/*}*/}

            <Modal
                shown={modalShownReferences}
                close={closeHandlerReferences}>
                <UserRequestCard
                    clickHandlerReferences={clickHandlerReferences}
                    setDescription={setDescription}
                    description={description}
                    userRequests={userRequests}
                    close={closeHandlerReferences}

                    //flag
                    //     type={document?.type}
                    // recrutment to work

                    //modal props
                    modalStatus={modalStatus}
                    setModalStatus={setModalStatus}
                    // selectedE={selectedE}
                    // setSelectedE={setSelectedE}
                    // setStageModalWindow={setStageModalWindow}
                    // testHOC={testHOC}
                />
            </Modal>
            {/*{*/}
            {/*    mode === "UNSTABLE" ?*/}
            {/*        <Modal shown={modalStatus} close={setModalStatus}>*/}
            {/*            <RecruitmentToWorkOnHolidaysModal*/}
            {/*                clickHandlerReferences={clickHandlerReferences}*/}
            {/*                selectedE={selectedE}*/}
            {/*                setSelectedE={setSelectedE}*/}
            {/*                setStageModalWindow={setStageModalWindow}*/}
            {/*                testHOC={testHOC}*/}
            {/*                setModalStatus={setModalStatus} />*/}
            {/*        </Modal> : null*/}
            {/*}*/}


        </div>
        );
};

export default React.memo(Applications);
